import React from "react";
import { FaBalanceScale, FaChartLine, FaRegClock, FaRobot } from "react-icons/fa";

function Features() {
  const features = [
    {
      icon: <FaBalanceScale className="fs-2 text-gold" />,
      title: "Gestão de Processos",
      description:
        "Controle andamentos, prazos, publicacoes e historicos em uma area central com leitura clara.",
    },
    {
      icon: <FaRobot className="fs-2 text-gold" />,
      title: "Inteligência Artificial",
      description:
        "Apoio para pecas, resumos e aceleracao de tarefas repetitivas com contexto juridico.",
    },
    {
      icon: <FaChartLine className="fs-2 text-gold" />,
      title: "Gestão Financeira",
      description:
        "Acompanhe entradas, saidas, cobrancas e indicadores para tomar decisoes com seguranca.",
    },
    {
      icon: <FaRegClock className="fs-2 text-gold" />,
      title: "Timesheet",
      description:
        "Registre horas, valorize tarefas e acompanhe produtividade por cliente, caso e equipe.",
    },
  ];

  return (
    <section id="funcionalidades" className="presentation-section">
      <div className="container presentation-shell px-4 px-lg-5 py-5">
        <div className="section-intro text-center mx-auto mb-5">
          <span className="section-kicker">Funcionalidades</span>
          <h2 className="section-title">Tudo o que a pagina inicial precisa comunicar</h2>
          <p className="section-description section-description-muted">
            Estruturei os principais modulos do produto em cards maiores,
            elegantes e com leitura rapida para melhorar a primeira impressao.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {features.map((feature, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3">
              <article className="feature-card h-100">
                <div className="feature-icon-wrap">{feature.icon}</div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
